import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex items-start space-x-2 h-14" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-1 grid-rows-3 max-h-10 self-start\"><div class=\"text-white text-xl font-thin\">beer</div><div class=\"text-white text-xl font-thin\">around</div><div class=\"text-white text-xl font-thin\">me</div></div><div class=\"text-2xl self-center\">🍻</div>", 2)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("🧭")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("🗺")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "bg-red-600 w-4 h-4 absolute left-7 top-7 rounded text-white text-xs" }, "2", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 🏠 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("🛠")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["bg-gray-800 top-0 left-0 right-0 h-14", {fixed: this.$route.path != '/map' && false}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, {
          to: "/radar",
          class: "btn btn-blue w-10 text-center self-center"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/map",
          class: "btn btn-blue w-10 text-center self-center"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/requests",
          class: "btn btn-blue w-10 text-center self-center relative"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/options",
          class: "btn btn-blue w-10 text-center self-center"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ], 2),
    _createVNode(_component_router_view)
  ]))
}